export const getDmPropsForChosenValues = (
  chosenValues: any[],
  dimensions: any,
  _configuratorContextId?: string,
  _preset?: any
): Record<string, any> =>
  Object.fromEntries(
    chosenValues.flatMap((valueId) => {
      let dynamakerValue: any = null

      const matchingDimensionObj = dimensions.find((dim: any) => {
        const matchingValueObj = dim.values.find((val: any) => val.valueId === valueId)

        if (matchingValueObj) {
          dynamakerValue = matchingValueObj.dynamakerValue
          return true
        }

        return false
      })

      if (!matchingDimensionObj) {
        if (![396, 400].includes(valueId)) {
          console.warn(
            `Unexpected: No matchingDimensionObj for valueId ${valueId} in getDmPropsForChosenValues${
              _configuratorContextId && _preset
                ? `, contextId: ${_configuratorContextId}, preset: ${JSON.stringify(_preset)}`
                : ''
            }`
          )
        }
        return []
      }

      const dynamakerCode = matchingDimensionObj.dynamakerCode

      if (dynamakerCode && !dynamakerValue) {
        console.warn(
          `Found dynamakerCode ${dynamakerCode} with dynamakerValue ${dynamakerValue} for valueId ${valueId}`
        )
        return []
      }

      if (!dynamakerCode && dynamakerValue) {
        console.warn(
          `Found dynamakerValue ${dynamakerValue} with dynamakerCode ${dynamakerCode} for valueId ${valueId}`
        )
        return []
      }

      if (dynamakerCode && dynamakerValue) {
        return [[dynamakerCode, dynamakerValue]]
      }

      // This LFC dimension has no matching DynaMaker prop
      return []
    })
  )
